import { render, staticRenderFns } from "./mainIndex.vue?vue&type=template&id=19f5fc2a&scoped=true&"
import script from "./mainIndex.vue?vue&type=script&lang=js&"
export * from "./mainIndex.vue?vue&type=script&lang=js&"
import style0 from "./mainIndex.vue?vue&type=style&index=0&id=19f5fc2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f5fc2a",
  null
  
)

export default component.exports